import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { UnitBreakdownActionTypes } from "./UnitBreakdown.type";

export function* fetchAllUnitBreakdownsPre(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/unit_breakdown/pre/?project_id=${action.payload.project_id}&date_type=${action.payload.date_type}&date=${action.payload.date}`
    );
    yield put({
      type: UnitBreakdownActionTypes.FETCH_ALL_UNIT_BREAK_DOWN_PRE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: UnitBreakdownActionTypes.FETCH_ALL_UNIT_BREAK_DOWN_PRE_FAILURE,
      payload: error,
    });
  }
}

export function* fetchAllUnitBreakdownsPost(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/unit_breakdown/post/?project_id=${action.payload.project_id}&date_type=${action.payload.date_type}&date=${action.payload.date}`
    );
    yield put({
      type: UnitBreakdownActionTypes.FETCH_ALL_UNIT_BREAK_DOWN_POST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: UnitBreakdownActionTypes.FETCH_ALL_UNIT_BREAK_DOWN_POST_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllUnitBreakdownsPre() {
  yield takeLatest(
    UnitBreakdownActionTypes.FETCH_ALL_UNIT_BREAK_DOWN_PRE,
    fetchAllUnitBreakdownsPre
  );
}

export function* watcherFetchAllUnitBreakdownsPost() {
  yield takeLatest(
    UnitBreakdownActionTypes.FETCH_ALL_UNIT_BREAK_DOWN_POST,
    fetchAllUnitBreakdownsPost
  );
}
